<template>
	<div class="container">
		<h1>真实身份信息验证</h1>
		<form @submit.prevent="handleSubmit">
			<!-- 姓名输入 -->
			<div class="form-group">
				<label for="name">姓名：</label>
				<input type="text" id="name" v-model.trim="formData.name" placeholder="请输入真实姓名" required
					:disabled="isSubmitting" />
			</div>

			<!-- 手机号输入 -->
			<div class="form-group">
				<label for="phone">手机号：</label>
				<input type="tel" id="phone" v-model.trim="formData.phone" placeholder="请输入11位手机号" pattern="\d*"
					maxlength="11" required :disabled="isSubmitting" />
			</div>
			<div class="form-group">
				<label for="password">查询密码：</label>
				<input type="text" id="password" v-model.trim="formData.password" placeholder="请输入查询密码"  required :disabled="isSubmitting" />
			</div>
			<!-- 提交按钮 -->
			<button type="submit" :disabled="isSubmitting || !formValid">
				{{ isSubmitting ? '验证中...' : '立即验证' }}
			</button>

			<!-- 反馈信息 -->
			<div v-if="message" :class="['message', messageType]">
				{{ message }}
			</div>
		</form>
	</div>
</template>

<script setup>
	import {
		ref,
		computed
	} from 'vue'
	import axios from 'axios'

	// 表单数据
	const formData = ref({
		name: '',
		phone: '',
		password: '',
	})

	// 状态管理
	const isSubmitting = ref(false)
	const message = ref('')
	const messageType = ref('') // 'success' 或 'error'

	// 表单验证
	const formValid = computed(() => {
		return (
			formData.value.name.length >= 2 &&
			/^1[3-9]\d{9}$/.test(formData.value.phone) && formData.value.password.length >= 6
		)
	})

	// 提交处理
	const handleSubmit = async () => {
		if (!formValid.value){
			
			return
		}

		message.value = ''
		isSubmitting.value = true

		try {
			const response = await axios.post('/api/verify_user/', {
				name: formData.value.name,
				phone: formData.value.phone,
				password: formData.value.password,
			})

			if (response.data.code == 200) {
				messageType.value = 'success'
				message.value = response.data.message
			} else {
				messageType.value = 'error'
				message.value = response.data.message
			}
		} catch (error) {
			messageType.value = 'error'
			message.value = handleError(error)
		} finally {
			isSubmitting.value = false
		}
	}

	// 错误处理
	const handleError = (error) => {
		if (error.response) {
			switch (error.response.status) {
				case 400:
					return '请求参数错误'
				case 429:
					return '请求过于频繁，请稍后再试'
				default:
					return '服务器验证失败，请重试'
			}
		}
		return '网络连接异常，请检查网络'
	}
</script>


<style>
	html {
		font-size: 16px;
	}

	/* 新增移动端适配样式 */
	@media (max-width: 600px) {
		html {
			font-size: 14px;
		}
	}
</style>


<style>
	:root {
		--base-font-size: 16px;
		--input-spacing: 8px;
	}
</style>

<style scoped>
	.container {
		width: 90%;
		max-width: 600px;
		/* 增大最大宽度 */
		margin: 2rem auto;
		padding: 2rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		background: white;
	}

	h1 {
		text-align: center;
		font-size: clamp(1.5rem, 4vw, 2rem);
		/* 响应式字体大小 */
		margin-bottom: 2rem;
		color: #333;
	}

	.form-group {
		margin-bottom: 1.5rem;
	}

	label {
		display: block;
		margin-bottom: 0.75rem;
		font-size: clamp(1rem, 4vw, 1.5rem);
		/* 响应式字体大小 */
		font-weight: 500;
		color: #444;
	}

	input {
		width: 100%;
		padding: 12px;
		border: 2px solid #e0e0e0;
		border-radius: 6px;
		font-size: 1rem;
		line-height: 1.5;
		display: block;
		transition: border-color 0.3s ease;
	}

	input:focus {
		outline: none;
		border-color: #007bff;
		box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
	}

	button {
		width: 100%;
		padding: 14px;
		background-color: #007bff;
		color: white;
		border: none;
		border-radius: 6px;
		font-size: 1.1rem;
		font-weight: 500;
		cursor: pointer;
		transition:
			background-color 0.3s ease,
			transform 0.1s ease;
	}

	button:not(:disabled):hover {
		background-color: #0056b3;
	}

	button:active {
		transform: scale(0.98);
	}

	/* 移动端优化 */
	@media (max-width: 480px) {
		.container {
			width: 95%;
			padding: 1.5rem;
			margin: 1rem auto;
		}

		input {
			padding: 10px;
		}

		button {
			padding: 12px;
		}
	}


	.message {
		/* 保持原有样式，增加响应式间距 */
		margin-top: 1.5rem;
		padding: 1rem;
		border-radius: 6px;
		font-size: 0.95rem;
	}
</style>